import { PropTypes } from 'prop-types'

const ToggleButton = ({ toggleFunc, toggled, hideImagePath, showImagePath }) => {
  return (
    <button type="button" className="px-2 py-2 bg-background absolute right-1 top-7" onClick={toggleFunc} tabIndex={-1}>
      <span className="absolute right-full top-1/2 transform -translate-y-1/2 h-1/2 border-l border"></span>
      <img
        src={toggled ? hideImagePath : showImagePath}
        alt={toggled ? 'Hide password' : 'Show password'}
        className="h-4  p-l-2"
      />
    </button>
  )
}

ToggleButton.propTypes = {
  toggleFunc: PropTypes.func.isRequired,
  toggled: PropTypes.bool.isRequired,
  hideImagePath: PropTypes.string.isRequired,
  showImagePath: PropTypes.string.isRequired,
}

export default ToggleButton
